import { render, staticRenderFns } from "./NEN5104Normalization.vue?vue&type=template&id=f4396fca&scoped=true"
import script from "./NEN5104Normalization.vue?vue&type=script&lang=js"
export * from "./NEN5104Normalization.vue?vue&type=script&lang=js"
import style0 from "./NEN5104Normalization.vue?vue&type=style&index=0&id=f4396fca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4396fca",
  null
  
)

export default component.exports